import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type AuditEntriesFetchFailedAction = {
	type: 'AUDIT_ENTRIES_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): AuditEntriesFetchFailedAction => ({
	type: 'AUDIT_ENTRIES_FETCH_FAILED',
	payload,
});
